import connectToStores from 'alt-utils/lib/connectToStores'
import React, { Component } from 'react'
import { Button, HelpEmail } from 'components'
import Snackbar from 'material-ui/Snackbar';
import { FontIcon } from 'material-ui';
import { GlobalErrorStore } from 'stores'
import { GlobalErrorActions } from 'actions'
import { AnalyticsUtils } from 'utils'

import './globalError.scss'

@connectToStores
export default class GlobalError extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  static getStores() {
    return [GlobalErrorStore]
  }

  static getPropsFromStores() {
    return GlobalErrorStore.getState()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.globalError) {
      AnalyticsUtils.errorViewed(this.context.currentUser.email, "global")
    }
  }

  render() {
    if (!this.props.globalError) return null;

    return (
      <div>
        <Snackbar
          open={true}
          message={
            <div>
              <div className="global-error__header">
                <FontIcon className="material-icons small-spacing--right" style={{fontSize: 32}}>error_outline</FontIcon>
                <h4>{ this.props.globalError }</h4>
              </div>
              <Button 
                label="Refresh and Try Again"
                buttonType="primary"
                className="medium-spacing2"
                onTouchTap={() => {window.location.reload()}}
              />
              <p>If the error persists email our team at <HelpEmail />. We'd be happy to help sort this out.</p>
            </div>
          }
          bodyStyle={{height: 'auto', lineHeight: '28px', padding: 24, whiteSpace: 'pre-line', backgroundColor: '#FFF', maxWidth: 'none', minWidth: '100%', textAlign: 'center'}}
          contentStyle={{color: '#212121'}}
          onRequestClose={ () => {} } 
          className="global-error"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/GlobalError.js